import { defaultMemoize } from 'reselect';
import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import {
  fontFamilyTokens,
  fontOverflowWrapTokens,
  fontSizeTokens,
  fontStyleTokens,
  fontWeightTokens,
} from '../../typography';

// This pattern is used to define multiple other tokens so we're using defaultMemoize to increase performance.
export const graphDefault = defaultMemoize(
  (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const common = {
      fontFamily: fontFamilyTokens(theme, parameters.lang),
      fontSize: fontSizeTokens(theme),
      fontWeight: fontWeightTokens(),
      fontStyle: fontStyleTokens().default,
      wrapText: fontOverflowWrapTokens(),
      // Temporary until visual design provides new neutral palette tokens
      n5: '#f8f9fa',
      n4: '#f2f3f5',
      n3: '#e9ecef',
      n2: '#cdd1d8',
      n1: '#b0b7c2',
      n: '#768396',
      n_1: '#636F80',
      n_2: '#3d4550',
      n_3: '#2b3138',
      n_5: '#171a1e',
      p2: '#44affc',
      p: '#147ACA',
      white: '#fff',
    };

    switch (theme.baseThemeName) {
      case 'dark': {
        return {
          ...common,
          color: '#696969',
          backgroundColor: '#021727',
        };
      }
      case 'high-contrast': {
        return {
          ...common,
          color: '#fff',
          backgroundColor: '#000',
        };
      }
      default: {
        return {
          ...common,
          color: '#696969',
          backgroundColor: '#fff',
        };
      }
    }
  }
);
